module.exports = __webpack_public_path__ + "Group 15707.b189e353571a125ef57d.png";